// icons
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import { ReactComponent as CSVIcon } from "@/assets/icons/fileTypes/CSV.svg";
import { ReactComponent as ExcelIcon } from "@/assets/icons/fileTypes/Excel.svg";
import { ReactComponent as ImageIcon } from "@/assets/icons/fileTypes/Image.svg";
import { ReactComponent as PDFIcon } from "@/assets/icons/fileTypes/PDF.svg";
import { ReactComponent as PowerpointIcon } from "@/assets/icons/fileTypes/Powerpoint.svg";
import { ReactComponent as TXTIcon } from "@/assets/icons/fileTypes/TXT.svg";
import { ReactComponent as WordIcon } from "@/assets/icons/fileTypes/Word.svg";
import { ReactComponent as ZIP } from "@/assets/icons/fileTypes/ZIP.svg";
import { TAttachmentType } from "@/Washouts/types/WashoutReview";

const iconMap = {
	png: ImageIcon,
	jpg: ImageIcon,
	jpeg: ImageIcon,
	gif: ImageIcon,
	bmp: ImageIcon,
	pdf: PDFIcon,
	txt: TXTIcon,
	doc: WordIcon,
	docx: WordIcon,
	xls: ExcelIcon,
	xlsx: ExcelIcon,
	ppt: PowerpointIcon,
	pptx: PowerpointIcon,
	csv: CSVIcon,
	zip: ZIP,
};

const style = {
	maxHeight: "1.25rem",
	minWidth: "1.5rem",
};

const GetIconByAttachmentType = (props: { type: TAttachmentType }) => {
	const { type } = props;

	const IconComponent = iconMap[type] ?? TextSnippetIcon;

	return <IconComponent style={style} />;
};

export default GetIconByAttachmentType;
